import React from "react";

export default ({prefix, text}) => <h2 className="main__heading"><strong>{prefix}</strong>{text}</h2>;